const namespace = "closeConfirmation";

export const MESSAGE = `${namespace}.message`;
export const LIMIT_REACHED_MESSAGE = `${namespace}.limitReachedMessage`;
export const CONFIRM = `${namespace}.confirm`;
export const DECLINE = `${namespace}.decline`;
